import { render, staticRenderFns } from "./LoginForgotPassword.vue?vue&type=template&id=80f3e24a"
import script from "./LoginForgotPassword.vue?vue&type=script&lang=js"
export * from "./LoginForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports